'use client';

import type { ReactNode } from 'react';
import { InformationCircleIcon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import { ReasonHeaderAction } from '../../tools/shared/reason-header-action';

export function HitlReviewReasonHeaderAction({
  reason,
}: {
  reason: string;
}): ReactNode {
  const t = useTranslations(
    'designSystem.chat.hitlRequestConfirmationPromptCard',
  );

  return (
    <ReasonHeaderAction
      title={t('guardrailReasonTooltipTitle')}
      reason={reason}
      icon={<InformationCircleIcon size={14} />}
      color="fg.muted"
    />
  );
}
